module.exports = __webpack_public_path__ + "media/images/icons/outlined/folder-1a3de6c43aa6dcd2872fab7e9bdb93c3.svg";